const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20avatar%20with%20pink%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20kawaii%20style%2C%20soft%20colors&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '樱花漫语',
    time: '2小时前',
    content: 'UU漫画的韩漫推荐真的绝了！之前漫荒了好久，跟着榜单一口气追了七八部，每部都超好看。特别是恋爱类的推荐，口味和我完全吻合。',
    comic: '在追《某天成为公主》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20male%20avatar%20with%20dark%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20shounen%20style%2C%20sharp%20features&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '热血少年郎',
    time: '5小时前',
    content: '日漫大全的分类做得太细了，热血、奇幻、悬疑一目了然。更新动态也很及时，再也不怕错过连载了。国漫榜单那边也挖到了几部宝藏作品。',
    comic: '在追《咒术回战》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Gentle%20anime%20style%20female%20avatar%20with%20brown%20long%20hair%20and%20glasses%2C%20simple%20illustration%2C%20clean%20background%2C%20soft%20warm%20colors&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '深夜读书人',
    time: '1天前',
    content: '作为一个国漫迷，UU漫画的国漫排行榜是我每天必刷的模块。古风仙侠类的推荐特别对我胃口，免费漫画大全这个定位太实在了，真的全免费。',
    comic: '在追《天官赐福》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Playful%20anime%20style%20male%20avatar%20with%20blonde%20hair%2C%20simple%20illustration%2C%20clean%20background%2C%20bright%20and%20cheerful%20style&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '漫无止境',
    time: '2天前',
    content: '从贴吧看到推荐过来的，没想到UU漫画的热门漫画类型这么全。话题标签功能也很有趣，能发现很多同好。最近沉迷悬疑推理类，根本停不下来。',
    comic: '在追《我独自升级》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">读者热评</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">来自漫友的真实声音</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((c, i) => (
            <div key={i} className="bg-background-50 rounded-lg border border-background-200/70 p-5">
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-1">
                    {[...Array(5)].map((_, j) => (
                      <i key={j} className="ri-star-fill text-xs text-secondary-500" />
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-xs text-foreground-600 leading-relaxed mb-2">{c.content}</p>
              <span className="inline-block text-xs text-accent-500 bg-accent-50 px-2 py-0.5 rounded">{c.comic}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}